import React, { useEffect, useState } from "react";
import { api, Banner, Button } from "./ui.tsx";
type Connection = {
  configured: boolean;
  connected: boolean;
  verified: false;
  error: string;
  redirectUri: string;
  message: string;
};
export function GoogleConnectionPanel() {
  const [state, setState] = useState<Connection | null>(null),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  async function load() {
    setError("");
    try {
      setState(await api("/google/connection"));
    } catch (e) {
      setError((e as Error).message);
    }
  }
  useEffect(() => {
    void load();
  }, []);
  async function connect() {
    setBusy(true);
    setError("");
    try {
      const { url } = await api<{ url: string }>("/google/connect", "POST");
      const target = new URL(url);
      if (
        target.protocol !== "https:" ||
        target.hostname !== "accounts.google.com" ||
        target.pathname !== "/o/oauth2/v2/auth"
      )
        throw Error("Endereço de autorização inválido.");
      window.location.assign(target.href);
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  }
  return (
    <section className="config-section" aria-label="Conexão da conta Google">
      <h3>Conta Google do gabinete</h3>
      {error && (
        <Banner kind="danger">
          {error} <Button onClick={load}>Tentar novamente</Button>
        </Banner>
      )}
      {!state ? (
        <p role="status">Conferindo conexão…</p>
      ) : (
        <>
          <Banner kind={state.error ? "warn" : "info"}>
            {state.error || state.message}
          </Banner>
          <p>
            A autorização permite consultar os arquivos da conta, trabalhar com
            as planilhas e criar arquivos pelo aplicativo. As pastas e planilhas
            usadas pelo gabinete continuam limitadas à configuração
            administrativa.
          </p>
          {!state.configured && (
            <p>
              Antes de conectar, configure o cliente OAuth e a proteção das
              credenciais no servidor. Nenhuma senha Google deve ser digitada
              aqui.
            </p>
          )}
          <Button
            kind="primary"
            disabled={!state.configured || busy}
            onClick={connect}
          >
            {busy
              ? "Abrindo Google…"
              : state.connected
                ? "Reconectar conta Google"
                : "Conectar conta Google"}
          </Button>
          <details>
            <summary>Configuração técnica no Google Cloud</summary>
            <p>
              Use um cliente OAuth do tipo Aplicativo da Web e cadastre
              exatamente este endereço de redirecionamento:
            </p>
            <code style={{ overflowWrap: "anywhere" }}>
              {state.redirectUri}
            </code>
            <p>
              Ative Google Sheets API e Google Drive API. Em modo de testes do
              Google, inclua a conta do gabinete entre os usuários de teste.
              Autorizar a conta não valida automaticamente os mapeamentos, nem
              confirma sincronização ou protocolo Solar.
            </p>
          </details>
        </>
      )}
    </section>
  );
}
